import { useCallback, useEffect, useState } from 'react';
import { getPartner, getPartnerAgencies, getPartnerCommercialOverview } from '../modules/crm/partners/partner.api';

const emptyOverview = { affairs: [], projects: [], quotes: [], activities: [], documents: [], metrics: {} };

export default function usePartnerDetails(id) {
  const [partner, setPartner] = useState(null);
  const [agencies, setAgencies] = useState([]);
  const [overview, setOverview] = useState(emptyOverview);
  const [loading, setLoading] = useState(true);
  const [agenciesLoading, setAgenciesLoading] = useState(false);
  const [overviewLoading, setOverviewLoading] = useState(true);
  const [error, setError] = useState(null);
  const [agenciesError, setAgenciesError] = useState(null);
  const [overviewError, setOverviewError] = useState(null);

  const loadPartner = useCallback(async () => {
    if (!id) return;
    try {
      setLoading(true);
      const data = await getPartner(id);
      setPartner(data); setAgencies(data.agencies); setError(null);
    } catch (requestError) {
      setError(requestError.message || 'Erreur lors du chargement du partenaire'); setPartner(null);
    } finally { setLoading(false); }
  }, [id]);

  const loadOverview = useCallback(async () => {
    if (!id) return;
    try { setOverviewLoading(true); setOverview(await getPartnerCommercialOverview(id)); setOverviewError(null); }
    catch (requestError) { setOverviewError(requestError.message); }
    finally { setOverviewLoading(false); }
  }, [id]);

  useEffect(() => { loadPartner(); }, [loadPartner]);
  useEffect(() => { loadOverview(); }, [loadOverview]);
  useEffect(() => {
    if (!id) return undefined;
    let active = true; setAgenciesLoading(true);
    getPartnerAgencies(id).then((rows) => { if (active) { setAgencies(rows); setAgenciesError(null); } })
      .catch((requestError) => { if (active) setAgenciesError(requestError.message); })
      .finally(() => { if (active) setAgenciesLoading(false); });
    return () => { active = false; };
  }, [id]);
  return { partner, setPartner, agencies, setAgencies, overview, setOverview, loading, error, setError,
    agenciesLoading, agenciesError, overviewLoading, overviewError, loadPartner, loadOverview };
}
